import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { AccountBreak, ShiftInitialsForAdd, ShiftInitialsForUpdate, defaultBreak, getDefaultBreak } from './interfaces/ShiftClass';
import { addAccountShiftAsync, updateAccountShiftAsync, resetSelectedRecordObjectInState, deleteAccountBreaksAsync } from './ShiftSlice';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import clsx from 'clsx';
import "react-datepicker/dist/react-datepicker.css";
import Select, { StylesConfig } from 'react-select';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import moment from 'moment';
import fetchAPI from '../../../common/fetchAPI';
import { isGuid, formatDateToTime, converToJsonDate, formatUniversalDateToTime, formatDateToTimeShift } from '../../../common/timeLiveFunction';
import { ShowSwalForCanvas } from '../../../common/SweetAlert';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { right } from '@popperjs/core';
import { KTIcon } from '../../../_metronic/helpers';
import { dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';
import CanvasLoader from '../../../common/CanvasLoader';
import TimePicker from "react-time-picker";
import BreakDurationField from './Breakdurationfield';
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from '../../../common/TooltipStyle';


const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
const ShiftForm = (props: any) => {
    const { t, tab, onSetActiveTab } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    // const [currentFieldsData, setCurrentFieldsData] = useState<any>(ShiftInitialsForAdd);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.shift);
    const [initialFormValues, setInitialFormValues] = useState(ShiftInitialsForAdd);
    const dispatch = useAppDispatch();
    const { maxMenuHeight } = useAppSelector(state => state.globalState);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [breakTypeArray, setBreakTypeArray] = useState<any | ''>([]);
    // const [controls, setControls] = useState<AccountBreak[]>([defaultBreak]);
    const [controls, setControls] = useState<AccountBreak[]>([getDefaultBreak()]);
    const [isCanvasLoader, setIsCanvasLoader] = useState(true);
    const formikRef = useRef<any>(null);
    const [hasBreakError, setHasBreakError] = useState(false);

    const getBreakTypesAsync = async () => {
        const response = await fetchAPI("api/V2/BreakType/DropDown", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json1 = await response.json();
        const json = json1?.Data;

        if (!Array.isArray(json) || json.length === 0) {
            setBreakTypeArray([{ value: "0", label: "Select" }]);
            return;
        }
        const transformedData = json.map((item: any) => ({
            value: item.AccountBreakTypeId,
            label: item.BreakType
        }));

        const defaultOption = { value: "0", label: "Select" };
        setBreakTypeArray([defaultOption, ...transformedData]);
    };

    const getDropdownByBreakTypeId = async (breakTypeId: any) => {
        const response = await fetchAPI("api/V2/BreakType/DropDown/" + breakTypeId, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
        const json = await response.json();
        if (json.Data) {
            const newOptions = json.Data.map((item: any) => ({
                value: item.AccountBreakTypeId,
                label: item.BreakType
            }));
            setBreakTypeArray([{ value: "0", label: "Select" }, ...newOptions]);
        }
    }

    useEffect(() => {
        getBreakTypesAsync();
    }, [])

    const getBreakTimeBreakdown = (time: string) => {
        if (!time) {
            return { BreakTimeText: '0 hr: 00 min', TotalMinutes: 0 };
        }
        const [hStr, mStr] = time.split(':');
        const hours = parseInt(hStr, 10) || 0;
        const minutes = parseInt(mStr, 10) || 0;
        const TotalMinutes = hours * 60 + minutes;
        const BreakTimeText = `${hours} hr: ${String(minutes).padStart(2, '0')} min`;
        return { BreakTimeText, TotalMinutes };
    }
    const addRow = () => {
        setControls([...controls, getDefaultBreak()]);
    };

    const handleSelectChange = (index: number, selectedValue: string) => {
        const updatedControls = controls.map((control, i) => {

            if (i === index) {
                return {
                    ...control,
                    AccountBreakTypeId: selectedValue
                };
            }
            return control;
        });
        setControls(updatedControls);
        if (Object.entries(selectedRecord).length > 0) {
            getDropdownByBreakTypeId(selectedValue);
        }
    };



    const handleTimeChange = (index: number, time: string) => {
        const updatedControls = controls.map((control, i) => {

            if (i === index) {
                return {
                    ...control,
                    BreakDuration: getBreakTimeBreakdown(time).TotalMinutes,//converToJsonDate(time),
                    BreakTime: time
                };
            }
            return control;
        });
        setControls(updatedControls);
    };

    const removeBreak = (indexToRemove: number, AccountBreakId: string) => {
        if (isGuid(AccountBreakId) && AccountBreakId !== '00000000-0000-0000-0000-000000000000') {
            ShowSwalWithConfirmation('Are you sure you want to delete this record?', "", "Yes, delete it!", "custom-swal-container")
                .then((result: any) => {
                    if (result) {
                        dispatch(deleteAccountBreaksAsync(AccountBreakId))
                            .unwrap()
                            .then((originalPromiseResult) => {
                                if (originalPromiseResult.StatusCode === "200") {
                                    ShowToast("Breaks Deleted Successfully", 'Success', "success", "toast-top-right");
                                    setControls(prevControls => prevControls.filter((_, index) => index !== indexToRemove));
                                }
                            })
                            .catch((rejectedValueOrSerializedError) => {

                            })
                    }
                })

        }
        else {
            setControls(prevControls => prevControls.filter((_, index) => index !== indexToRemove));
        }

    }
    useEffect(() => {
        setIsCanvasLoader(true);
        let stateItem: any = {};
        let currentInitials = { ...ShiftInitialsForAdd };

        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(ShiftInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            const formattedStart = formatDateToTimeShift(stateItem.StartTime);
            const formattedEnd = formatDateToTimeShift(stateItem.EndTime);
            stateItem.StartTime = formattedStart;
            stateItem.EndTime = formattedEnd;

            stateItem.ShiftCutoffTime = stateItem.ShiftCutoffTime;

            setInitialFormValues(stateItem);
            currentInitials = stateItem;
            const updatedBreakTypeArray = breakTypeArray.slice();
            stateItem.Breaks.forEach((breakItem: any) => {
                if (breakItem.AccountBreakTypeId === '0') return;
                const existingBreakType = updatedBreakTypeArray.find(
                    (type: any) => type.value === breakItem.AccountBreakTypeId
                );
                if (!existingBreakType) {
                    updatedBreakTypeArray.push({
                        value: breakItem.AccountBreakTypeId,
                        label: breakItem.AccountBreakType,
                    });
                }
            });
            setBreakTypeArray(updatedBreakTypeArray);

            if (stateItem.Breaks.length > 0) {
                const newControls = stateItem.Breaks.map((item: any) => {
                    const totalMinutes = parseInt(item.BreakDuration, 10) || 0;
                    const hours = Math.floor(totalMinutes / 60);
                    const mins = totalMinutes % 60;
                    const formattedTimeStr = `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
                    return {
                        AccountBreakId: item.AccountBreakId,
                        AccountBreakTypeId: item.AccountBreakTypeId,
                        BreakDuration: item.BreakDuration,
                        BreakTime: formattedTimeStr
                    };
                });
                setControls(newControls);
            } else {
                setControls([getDefaultBreak()]);
            }
            setIsCanvasLoader(false);

        } else {
            const addInitials = {
                ...ShiftInitialsForAdd,
                StartTime: moment().format('HH:mm:ss'),
                EndTime: moment().format('HH:mm:ss'),
            };
            setInitialFormValues(addInitials);
            currentInitials = addInitials;
            setControls([getDefaultBreak()]);
            setIsCanvasLoader(false);
        }

        onSetActiveTab('Shift');
        setHasBreakError(false);

        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }


        if (formikRef.current) {
            formikRef.current.resetForm({ values: currentInitials });
        }
    }, [selectedRecord]);

    const handleSubmit = (values: any) => {
        let filteredAccountBreaks: any = [];

        if (controls.length > 0) {

            filteredAccountBreaks = controls
                .filter((breakItem) => {
                    return isGuid(breakItem.AccountBreakTypeId) && breakItem.AccountBreakTypeId !== '00000000-0000-0000-0000-000000000000';
                })
                .map((breakItem) => {
                    const { TotalMinutes } = getBreakTimeBreakdown(breakItem.BreakTime);
                    return {
                        ...breakItem,
                        BreakDuration: TotalMinutes,
                    };
                });
        }

        const formValues = { ...values };
        const today = new Date().toISOString().split('T')[0];
        // if (formValues.StartTime && !formValues.StartTime.toString().includes('/Date(')) {
        //     formValues.StartTime = converToJsonDate(formValues.StartTime);
        // }
        // if (formValues.EndTime && !formValues.EndTime.toString().includes('/Date(')) {
        //     formValues.EndTime = converToJsonDate(formValues.EndTime);
        // }
        if (formValues.StartTime && !formValues.StartTime.toString().includes('/Date(')) {
            formValues.StartTime = `${today}T${formValues.StartTime}`;
        }
        if (formValues.EndTime && !formValues.EndTime.toString().includes('/Date(')) {
            formValues.EndTime = `${today}T${formValues.EndTime}`;
        }
        if (Object.keys(selectedRecord).length > 0) {
            formValues.Breaks = filteredAccountBreaks;
            delete formValues.Breaks;
            delete formValues.IsDeleted;
            dispatch(updateAccountShiftAsync({ AccountShift: formValues, AccountBreaks: filteredAccountBreaks }))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Shift Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                });
        }
        else {
            formValues.Breaks = filteredAccountBreaks;
            delete formValues.Breaks;
            delete formValues.IsDeleted;
            delete formValues.IsDisabled;
            filteredAccountBreaks.forEach((item: any) => {
                delete item.AccountBreakId;
            });
            dispatch(addAccountShiftAsync({ AccountShift: formValues, AccountBreaks: filteredAccountBreaks }))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Shift Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                });
        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    };
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
        setHasBreakError(false);
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
        onSetActiveTab('Shift');
    }

    return (
        <>
            <Formik
                innerRef={formikRef}
                // initialValues={currentFieldsData}
                initialValues={initialFormValues}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    Name: yup
                        .string()
                        .label
                        // (t('Name'))
                        (getValueFromResource('Name', dispatch, t))
                        .trim()
                        .required
                        // (t('Shift Name field is Required.')),
                        (getValueFromResource('Shift Name field is Required.', dispatch, t)),
                    StartTime: yup.string().required
                        // ('Start time is required'),
                        (getValueFromResource('Start time is required', dispatch, t)),
                    EndTime: yup.string().required
                        // ('End time is required')
                        (getValueFromResource('End time is required', dispatch, t)),
                    ShiftCutoffTime: yup.string().required
                        (getValueFromResource('Shift cutoff time is required', dispatch, t))
                        .test(
                            'cutoff-before-start',
                            getValueFromResource(
                                'Shift cutoff time must be less than start time',
                                dispatch,
                                t
                            ),
                            function (value) {
                                const { StartTime } = this.parent;
                                if (!value || !StartTime) {
                                    return true;
                                }
                                const cutoffTime = value.substring(0, 5);
                                const startTime = StartTime.substring(0, 5);
                                return cutoffTime < startTime;
                            }
                        )
                })}>
                {({ values, handleChange, setFieldValue, setFieldError, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <div className='card-body' style={{ padding: '0rem 2.25rem' }}>
                            {isCanvasLoader ? <CanvasLoader /> : <>

                                <div className='card-header' style={{ marginLeft: '-30px' }}>

                                    <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap mt-4' role='tablist'>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Shift' })}
                                                onClick={() => onSetActiveTab('Shift')}
                                                role='tab'
                                                style={{ fontWeight: 500 }}
                                            >

                                                {getValueFromResource('Shift', dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Breaks' })}
                                                onClick={() => onSetActiveTab('Breaks')}
                                                role='tab'
                                                style={{ fontWeight: 500 }}
                                            >

                                                {getValueFromResource('Breaks', dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Permissions' })}
                                                onClick={() => onSetActiveTab('Permissions')}
                                                role='tab'
                                                style={{ fontWeight: 500 }}
                                            >

                                                {getValueFromResource('Permissions', dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Settings' })}
                                                onClick={() => onSetActiveTab('Settings')}
                                                role='tab'
                                                style={{ fontWeight: 500 }}
                                            >

                                                {getValueFromResource('Settings', dispatch, t)}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className='tab-content mt-5'>
                                    <div className={clsx('tab-pane', { active: tab === 'Shift' })}>
                                        <div className='row'>
                                            <div className="col-md-6 mb-3 ">
                                                <label className="fs-7 fw-normal mb-2">

                                                    {getValueFromResource('Shift Name', dispatch, t)}
                                                </label>
                                                <input type="text"
                                                    className="form-control fs-7 fw-normal"
                                                    id='Name'
                                                    name='Name'
                                                    value={values.Name}
                                                    onChange={handleChange('Name')}
                                                    ref={defaultFocusRef}
                                                // onBlur={() => setFieldTouched('Name')}
                                                />
                                                <div style={{ paddingRight: 0, paddingLeft: 0 }}>
                                                    {touched.Name && errors.Name &&
                                                        <p className='errorMsg'>{errors.Name as string}</p>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3 ">
                                                <label className="fs-7 fw-normal mb-2">

                                                    {getValueFromResource('Shift Code', dispatch, t)}
                                                </label>
                                                <input type="text"
                                                    className="form-control fs-7 fw-normal"
                                                    id='Code'
                                                    name='Code'
                                                    value={values.Code}
                                                    onChange={handleChange('Code')}
                                                // onBlur={() => setFieldTouched('Code')}
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3 mt-2">
                                                <label className="fs-7 fs-7 fw-normal mb-2">

                                                    {getValueFromResource('Start Time', dispatch, t)}
                                                </label>
                                                <div className="wrapper">
                                                    <TimePicker
                                                        value={values.StartTime}

                                                        onChange={(time) => setFieldValue("StartTime", time || "")}
                                                        clearIcon={null}
                                                        format="hh:mm a"
                                                        className="form-control fs-7 fw-normal"
                                                        id="StartTime"
                                                        disableClock={false}
                                                    />
                                                    <div style={{ paddingRight: 0, paddingLeft: 0 }}>
                                                        {touched.StartTime && errors.StartTime &&
                                                            <p className='errorMsg'>{errors.StartTime as string}</p>
                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-md-6 mb-3 mt-2">
                                                <label className="fs-7 fs-7 fw-normal mb-2">

                                                    {getValueFromResource('End Time', dispatch, t)}
                                                </label>
                                                <div className="wrapper">
                                                    <TimePicker
                                                        value={values.EndTime}

                                                        onChange={(time) => setFieldValue("EndTime", time || "")}
                                                        clearIcon={null}
                                                        format="hh:mm a"
                                                        className="form-control fs-7 fw-normal"
                                                        id="EndTime"
                                                        disableClock={false}
                                                    />
                                                    <div style={{ paddingRight: 0, paddingLeft: 0 }}>
                                                        {touched.EndTime && errors.EndTime &&
                                                            <p className='errorMsg'>{errors.EndTime as string}</p>
                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-md-6 mb-3 mt-2">
                                                <label className="fs-7 fs-7 fw-normal mb-2">
                                                    {getValueFromResource('Shift Cutoff Time', dispatch, t)}
                                                </label>
                                                <div className="wrapper">
                                                    <TimePicker
                                                        value={values.ShiftCutoffTime}
                                                        onChange={(time) => setFieldValue("ShiftCutoffTime", time || "")}
                                                        clearIcon={null}
                                                        format="hh:mm a"
                                                        className="form-control fs-7 fw-normal"
                                                        id="ShiftCutoffTime"
                                                        disableClock={false}
                                                    />
                                                    <div style={{ paddingRight: 0, paddingLeft: 0 }}>
                                                        {touched.ShiftCutoffTime && errors.ShiftCutoffTime &&
                                                            <p className='errorMsg'>{errors.ShiftCutoffTime as string}</p>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className='col-md-6 mb-3 mt-2'>
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {getValueFromResource('Allow Overnight Shift', dispatch, t)}
                                                </label>

                                                <div className="col-md-6 mb-3 mt-2">
                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                        <input className="form-check-input h-20px w-30px"
                                                            type="checkbox"
                                                            id="AllowOvernightShift"
                                                            name="AllowOvernightShift"
                                                            checked={values.AllowOvernightShift}
                                                            onChange={handleChange('AllowOvernightShift')}
                                                        />
                                                    </div>
                                                </div>
                                            </div> */}



                                            <div className="col-md-12 mb-3 mt-2" >
                                                <label className="fs-7 fs-7 fw-normal mb-2">

                                                    {getValueFromResource('Notes', dispatch, t)}
                                                </label>
                                                <textarea
                                                    rows={4}
                                                    cols={50}
                                                    placeholder=

                                                    {getValueFromResource('Enter your text here...', dispatch, t)}
                                                    id='Description'
                                                    name='Description'
                                                    value={values.Description || ""}
                                                    className="form-control fs-7 fw-normal"
                                                    onChange={handleChange('Description')}

                                                />
                                            </div>
                                            {(Object.keys(selectedRecord).length > 0) ? (
                                                <div className="col-md-6 mb-3">
                                                    <label className="fs-7 fs-7 fw-normal mb-2">

                                                        {getValueFromResource('Disabled', dispatch, t)}
                                                    </label>
                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                        <input className="form-check-input h-20px w-30px"
                                                            type="checkbox"
                                                            checked={values.IsDisabled}
                                                            id="IsDisabled"
                                                            name="IsDisabled"
                                                            onChange={handleChange('IsDisabled')}
                                                        />
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className={clsx('tab-pane', { active: tab === 'Breaks' })}>
                                        <div className="row mb-3">
                                            <div className="col-md-7"></div>
                                            <div className="col-md-5 d-flex justify-content-end">
                                                <button
                                                    className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm p-2 fs-7"
                                                    onClick={addRow}>
                                                    <KTIcon iconName='plus' className='fs-5 px-0' />

                                                    {getValueFromResource('Add Break', dispatch, t)}
                                                </button>
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-5">
                                                <label className="form-check-label">

                                                    {getValueFromResource('Break Type', dispatch, t)}
                                                </label>
                                            </div>
                                            <div className="col-md-5">
                                                <label className="form-check-label">

                                                    {getValueFromResource('Break Duration', dispatch, t)}
                                                </label>
                                            </div>

                                        </div>
                                        {controls && controls.map((control: any, index: number) => (
                                            <div className='row' key={`${index}-${control.AccountBreakTypeId}`}>
                                                <div className="col-md-5 mb-1">
                                                    <Select
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        isSearchable={true}
                                                        onMenuOpen={() => {
                                                            if (Object.entries(selectedRecord).length > 0) {
                                                                getDropdownByBreakTypeId(control.AccountBreakTypeId);
                                                            }
                                                        }}
                                                        onChange={(selectedOption: any) =>
                                                            handleSelectChange(index, selectedOption?.value || '')
                                                        }
                                                        value={breakTypeArray.find(
                                                            (option: any) =>
                                                                option.value.toLowerCase() ===
                                                                control.AccountBreakTypeId.toLowerCase()
                                                        )}
                                                        options={
                                                            breakTypeArray.filter(
                                                                (option: any) => !controls.some(
                                                                    (ctrl) => ctrl.AccountBreakTypeId === option.value && ctrl !== control
                                                                )
                                                            ).map((option: any) => ({
                                                                value: option.value,
                                                                label: option.label
                                                            }))
                                                        }
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight} />
                                                </div>
                                                <div className="col-md-5 mb-1">
                                                    {/* <BreakDurationField
                                                        value={control.BreakTime}
                                                        onChange={(time: any) => handleTimeChange(index, time)}
                                                        maxMenuHeight={maxMenuHeight}
                                                    /> */}
                                                    <BreakDurationField
                                                        value={control.BreakTime}
                                                        onChange={(time: any) => handleTimeChange(index, time)}
                                                        onErrorChange={(errMsg: string) => {
                                                            setHasBreakError(!!errMsg);
                                                        }}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                </div>
                                                <div className="col-md-2 mb-1 mt-1 d-flex align-items-center">
                                                    <span className="menu-icon custom-menu">
                                                        <i className="bi bi-trash fs-6 delete-menu-icon-color cursor-pointer symbol" onClick={() => removeBreak(index, control.AccountBreakId)}>
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                </div>

                                            </div>
                                        ))}
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Permissions' })}>
                                        <div className='row'>
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Allow location sharing')} */}
                                                {getValueFromResource('Allow Location Sharing', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-shiftForm"
                                                    data-tooltip-content={getValueFromResource('Capture and store the device’s latitude and longitude when attendance is marked, ensuring location-based validation of attendance activities.', dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <div className="col-md-6 mb-3">
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input className="form-check-input h-20px w-30px"
                                                        type="checkbox"
                                                        id="AllowLocationInWeb"
                                                        name="AllowLocationInWeb"
                                                        checked={values.AllowLocationInWeb}
                                                        onChange={handleChange('AllowLocationInWeb')}
                                                    />
                                                    <label className="fs-7 fw-normal ms-2" htmlFor="AllowLocationInWeb">
                                                        {/* {t('Web Clock-In / Clock-Out')} */}
                                                        {getValueFromResource('Web Clock-In / Clock-Out', dispatch, t)}
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input className="form-check-input h-20px w-30px"
                                                        type="checkbox"
                                                        id="AllowLocationInMobile"
                                                        name="AllowLocationInMobile"
                                                        checked={values.AllowLocationInMobile}
                                                        onChange={handleChange('AllowLocationInMobile')}
                                                    />
                                                    <label className="fs-7 fs-7 fw-normal ms-2" htmlFor="AllowLocationInMobile">
                                                        {/* {t('Mobile Clock-In / Clock-Out')} */}
                                                        {getValueFromResource('Mobile Clock-In / Clock-Out', dispatch, t)}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mb-2 mt-2'>
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Allow photo capture')} */}
                                                {getValueFromResource('Allow Photo Capture', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-shiftForm"
                                                    data-tooltip-content={getValueFromResource('Enable photo capture during attendance actions. This feature is only available when using the Kiosk application for identity verification and enhanced attendance security.', dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <div className="col-md-6 mb-3 mt-2">
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input className="form-check-input h-20px w-30px"
                                                        type="checkbox"
                                                        id="AllowPhotoCapture"
                                                        name="AllowPhotoCapture"
                                                        checked={values.AllowPhotoCapture}
                                                        onChange={handleChange('AllowPhotoCapture')}
                                                    />
                                                    <label className="fs-7 fs-7 fw-normal ms-2" htmlFor="AllowPhotoCapture">
                                                        {/* {t('Mobile Clock-In / Clock-Out')} */}
                                                        {getValueFromResource('Mobile Clock-In / Clock-Out', dispatch, t)}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Settings' })}>
                                        <div className='row'>
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Allow Department selection')} */}
                                                {getValueFromResource('Allow Department Selection', dispatch, t)}
                                            </label>
                                            <div className="col-md-6 mb-3">
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input className="form-check-input h-20px w-30px"
                                                        type="checkbox"
                                                        id="AllowDepartmentInAttendance"
                                                        name="AllowDepartmentInAttendance"
                                                        checked={values.AllowDepartmentInAttendance}
                                                        onChange={handleChange('AllowDepartmentInAttendance')}
                                                    />
                                                    <label className="fs-7 fs-7 fw-normal ms-2" htmlFor="AllowDepartmentInAttendance">
                                                        {/* {t('Mobile Clock-In / Clock-Out')} */}
                                                        {getValueFromResource('Mobile Clock-In / Clock-Out', dispatch, t)}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        {values.AllowDepartmentInAttendance ? (
                                            <div className='row mt-2'>
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Mandatory Department selection')} */}
                                                    {getValueFromResource('Mandatory Department Selection', dispatch, t)}
                                                </label>
                                                <div className="col-md-6 mb-3">
                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                        <input className="form-check-input h-20px w-30px mt-2"
                                                            type="checkbox"
                                                            id="DepartmentSelectionInAttendance"
                                                            name="DepartmentSelectionInAttendance"
                                                            checked={values.DepartmentSelectionInAttendance}
                                                            onChange={handleChange('DepartmentSelectionInAttendance')}
                                                        />
                                                        <label className="fs-7 fs-7 fw-normal ms-2" htmlFor="DepartmentSelectionInAttendance">
                                                            {/* {t('Clock-In / Clock-Out')} */}
                                                            {getValueFromResource('Clock-In / Clock-Out', dispatch, t)}
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                        <input className="form-check-input h-20px w-30px mt-2"
                                                            type="checkbox"
                                                            id="DepartmentSelectionInBreak"
                                                            name="DepartmentSelectionInBreak"
                                                            checked={values.DepartmentSelectionInBreak}
                                                            onChange={handleChange('DepartmentSelectionInBreak')}
                                                        />
                                                        <label className="fs-7 fs-7 fw-normal ms-2" htmlFor="DepartmentSelectionInBreak">
                                                            {/* {t('Break-In / Break-Out')} */}
                                                            {getValueFromResource('Break-In / Break-Out', dispatch, t)}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}
                                        <div className="col-md-12 mb-3 mt-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Total hours calculation')} */}
                                                {getValueFromResource('Total Hours Calculation', dispatch, t)}
                                            </label>
                                            <div className="">
                                                <div className="form-check form-check-custom form-check-solid form-check-sm">
                                                    <input
                                                        className="form-check-input"
                                                        id="TotalHoursCalculation"
                                                        type="radio"
                                                        value={values.TotalHoursCalculation}
                                                        checked={values.TotalHoursCalculation === "firstcheckin"}
                                                        onChange={() => setFieldValue('TotalHoursCalculation', "firstcheckin")}
                                                    />
                                                    <label className="fs-7 fs-7 fw-normal mb-1 ms-2 mt-2" style={{ color: '#3f4254', fontWeight: 500 }}>
                                                        {/* {t('First Clock-In & Last Clock-Out')} */}
                                                        {getValueFromResource('First Clock-In & Last Clock-Out', dispatch, t)}
                                                    </label>

                                                    <input
                                                        className="form-check-input ms-8"
                                                        id="TotalHoursCalculation"
                                                        type="radio"
                                                        value={values.TotalHoursCalculation}
                                                        checked={values.TotalHoursCalculation === "everyvalidcheckin"}
                                                        onChange={() => setFieldValue('TotalHoursCalculation', "everyvalidcheckin")}
                                                    />
                                                    <label className="fs-7 fs-7 fw-normal mb-1 ms-2 mt-2 " style={{ color: '#3f4254', fontWeight: 500 }}>
                                                        {/* {t('Every Valid Clock-In & Clock-Out')} */}
                                                        {getValueFromResource('Every Valid Clock-In & Clock-Out', dispatch, t)}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            }
                            {Object.keys(errors).length > 0 && (
                                <div className="mt-3 alert alert-danger">
                                    <strong>

                                        {getValueFromResource('Error Summary', dispatch, t)}:
                                    </strong>
                                    <ul>

                                        {Object.keys(errors).map((fieldName, index) => (
                                            <li key={index}>{(errors as Record<string, string>)[fieldName]}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <div className='card-footer pt-4 '>
                            <div className='d-flex flex-stack float-end'>
                                <div className='d-flex align-items-center me-2'>
                                    <button
                                        ref={closeButtonRef}
                                        type="button"
                                        className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                        id="kt_OffCanvas"
                                        onClick={handleCloseOnClickEvent}
                                    >
                                        {getValueFromResource('Cancel', dispatch, t)}
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary"
                                        onClick={() => handleSubmit()} disabled={!isValid || hasBreakError}
                                        data-kt-element='send'
                                    >
                                        {getValueFromResource('Save', dispatch, t)}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik >
            <ReactTooltip
                id="tooltip-shiftForm"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
}

export default ShiftForm